<div class="loading-overlay" *ngIf="show() || (loadingGkService.isLoading | async)">
	<div class="loading-content">
		<img
			src="assets/layout/images/branding/gainkode-simbolo.svg"
			[alt]="'brand.name' | transloco"
			class="loading-logo"
		>
	</div>
</div>
